'use client';

import { use } from 'react';
import { Context } from './electricity-tariffs-context';

export const useElectricityTariffs = () => {
  const tariffsPromise = use(Context);
  if (!tariffsPromise) {
    return null;
  }

  return use(tariffsPromise).data;
};

export const useElectricityProduct = (productCode: string | undefined) => {
  const tariffs = useElectricityTariffs();

  if (!productCode) {
    return;
  }

  return tariffs?.tariffs.find((product) => product.productCode === productCode);
};
